import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class GridViewService {

    constructor(private http: HttpServices, private _http: HttpClient) { }

    getCollectionPagedSorted(collectionPagingEndPoint) {
        return this.http.get(collectionPagingEndPoint);
    }
}